import './depositsProductCMSBanners.scss';

// @vendors
const React = require('react');
import PropTypes from 'prop-types';
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@components
const InterestsExample = require('components/interestsExample/interestsExample');
import { OfferExamples } from 'components/offersExample/offersExample';
const ProductBanner = require('components/commons/productBanner/productBanner');
const { LoadingSection } = require('commonsComponents/loadingSection');
const RiskProduct = require('components/riskProduct/riskProduct');
//@core
const { FormattedText }= require('core/i18n').i18n;
// constants
const DEPOSITS_PRODUCT_BANNERS = require ('constants/productBanners/depositsProductBanners');

class DepositsProductCMSBanners extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    filteredProducBanners () {
        const { immFlagBasedFeatures } = this.props;
        return (
            DEPOSITS_PRODUCT_BANNERS
            .filter( banner => immFlagBasedFeatures.get(banner.featureFlag))
        )
    }

    buildProductBanners() {
        const { immHiringProductBanners } = this.props;
        const immProductBanners = immHiringProductBanners.get('productBanners') || [];
        const bannerOrder = immProductBanners.map((banner) => banner.get('codeType'));

        return bannerOrder.map((bannerKey, index) => {
            const immBanner = immProductBanners.find(banner => banner.get('codeType') === bannerKey);

            const alias = immBanner.get('alias');
            const title = immBanner.get('title');
            const subtitle = immBanner.get('subtitle');
            const immAdvantages = immBanner.get('advantages');
            const link = immBanner.get('link');
            const sidebarImgUrl = immBanner.get('sidebarImgUrl');
            let advantages = [];
            //Parse advantages
            if (immAdvantages) {
                advantages = immAdvantages.toJS();
            }
            //Parse image details
            const immSidebarImgDetails = immBanner.get('sidebarImageDetails');
            const sidebarImgAlt = immSidebarImgDetails.get('sidebarImgAlt');

            return (
                <ProductBanner
                    id={alias}
                    key={`product-cms-banners-${index}`}
                    advantages={advantages}
                    link={link}
                    subtitle={subtitle}
                    title={title}
                    sidebarImgAlt={sidebarImgAlt}
                    sidebarImgUrl={sidebarImgUrl}
                    linkText="productBanner-productBanner_depositsButton"
                />
            );
        });
    }

    render () {
        const {
            immFlagBasedFeatures,
            immHiringProductBanners,
            offersData,
            offerExamplesData, 
            originCountry
        } = this.props;
        const hasRenewalOffers = offersData && Object.keys(offersData).length;
        const banners = this.buildProductBanners();
        let depositsbanner;

        if (immHiringProductBanners.get('isFetching') ) {
            depositsbanner = <LoadingSection />
        } else if (this.filteredProducBanners().length > 0) {
            depositsbanner = (
                <section className="deposits-product-cms-banners">
                    <header className="deposits-product-cms-banners__header">
                        <FormattedText value="productBanner-meetDeposits" />
                    </header>
                    {
                        !hasRenewalOffers && (
                            <RiskProduct
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                isAlertLiquidity={true}
                            />
                        )
                    }
                    {banners}
                    <div className="deposits-product-banners__examples">
                        <OfferExamples examples={offerExamplesData} originCountry={originCountry} />
                        <InterestsExample reducedTopSpacing={!!offerExamplesData.length} keyText={'productBanner-productBanner_depositsInterestsExample'} />
                    </div>
                </section>
            );
        } else {
            depositsbanner = (
                <section className="deposits-product-banners">
                    <div className="deposits-product-banners__examples">
                        <OfferExamples examples={offerExamplesData} originCountry={originCountry} />
                    </div>
                </section>
            );
        }

        return depositsbanner;
    }
}

DepositsProductCMSBanners.propTypes = {
    immDeposits: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHiringProductBanners: PropTypes.object.isRequired,
    offersData: PropTypes.object.isRequired,
};

module.exports = DepositsProductCMSBanners;
